import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import {validateEmailFunc } from '../../../../common/utils/utilsFunc'

const PersonalData = ({props}) => {
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });

    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (props.values.name) {
            errors.empty.name = false;
        } else {
            errors.empty.name = true;
            errors.msg.name = "Debe ingresar un nombre"
        }

        if (props.values.paternalSurname) {
            errors.empty.paternalSurname = false;
        } else {
            errors.empty.paternalSurname = true;
            errors.msg.paternalSurname = "Debe ingresar un apellido paterno"
        }

        if (props.values.maternalSurname) {
            errors.empty.maternalSurname = false;
        } else {
            errors.empty.maternalSurname = true;
            errors.msg.maternalSurname = "Debe ingresar un apellido materno"
        }

        if (props.values.street) {
            errors.empty.street = false;
        } else {
            errors.empty.street = true;
            errors.msg.street = "Debe ingresar una calle"
        }

        if (props.values.number) {
            errors.empty.number = false;
        } else {
            errors.empty.number = true;
            errors.msg.number = "Debe ingresar un numero"
        }

        if (props.values.region) {
            errors.empty.region = false;
        } else {
            errors.empty.region = true;
            errors.msg.region = "Debe selecionar una region"
        }

        if (props.values.commune) {
            errors.empty.commune = false;
        } else {
            errors.empty.commune = true;
            errors.msg.commune = "Debe selecionar una comuna"
        }

        if(props.values.telephone && isNaN(props.values.telephone)) {
            errors.empty.telephone = true;
            errors.msg.telephone = "Este campo no puede contener letras";
        } else {
            if(props.values.telephone && props.values.telephone.length !== 8 && props.values.telephone.length !== 7){
                errors.empty.telephone = true;
                errors.msg.telephone = "El número debe contener 7 o 8 dígitos";
            }else{
                errors.validated.telephone = false;
            }
        }

        if (props.values.cellPhone) {
            if(isNaN(props.values.cellPhone)) {
                errors.empty.cellPhone = true;
                errors.msg.cellPhone = "Este campo no puede contener letras";
            } else {
                if(props.values.cellPhone.length !== 9){
                    errors.empty.cellPhone = true;
                    errors.msg.cellPhone = "El número debe contener 9 dígitos";
                } else {
                    errors.empty.cellPhone = false;  
                }  
            }
        } else {
            errors.empty.cellPhone = true;
            errors.msg.cellPhone = "El celular es obligatorio";
        }

        if (props.values.email) {
            errors.empty.email = false;
            if (props.values.email && !validateEmailFunc(props.values.email)) {
                errors.validated.email = true;
                errors.msg.email = "Debes ingresar un correo electrónico válido"
            } else {
                errors.validated.email = false;
            }
        } else {
            errors.empty.email = true;
            errors.msg.email = "Debes ingresar el correo electrónico"
        }

        if (props.values.confirmEmail) {
            errors.empty.confirmEmail = false;
            if (props.values.confirmEmail && !validateEmailFunc(props.values.confirmEmail)) {
                errors.validated.confirmEmail = true;
                errors.msg.confirmEmail = "Debe ingresar el Correo Electrónico válido  para confirmar"
            } else if (props.values.confirmEmail !== props.values.email) {
                errors.validated.confirmEmail = true;
                errors.msg.confirmEmail = "Los Correos Electrónicos no coinciden"
            } else {
                errors.validated.confirmEmail = false;
            }
        } else {
            errors.empty.confirmEmail = true;
            errors.msg.confirmEmail = "Debe confirmar el Correo Electrónico"
        }

        setInputValidate(errors)
        return errors
    }

    function handleSubmit() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else {
            let json = {
                    "given_name": props.values.name,
                    "phone_number": props.values.cellPhone?"+56"+props.values.cellPhone:"",
                    "email": props.values.email,
                    "family_name": props.values.paternalSurname,
                    "custom:second_family_name": props.values.maternalSurname,
                    "custom:address_number": props.values.number,
                    "custom:address_commune": props.values.commune,
                    "custom:address_street": props.values.street,
                    "custom:address_region": props.values.region,
                    "custom:address_building": props.values.dpto,
                    "custom:email_newsletter": props.checkBox,
                    "custom:house_phone_number": props.values.telephone?props.values.prefixCell+props.values.telephone:""
                }
            
            props.setJsonForm(json)
        }

    }

    React.useEffect(() => {
        props.setIdRegion(props.values.region);
        if(Number(props.values.region) === 0){
            props.setValues({ ...props.values, commune: "" });
        }
    },[props.values.region]);
    
  return (
    <div>
        <CGE.Panel title={props.title_datos_personales}>
            <CGE.PanelSection title={props.title_section_datos_personales_1}>
                <div className="row">
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, name: e.target.value })}
                            idFormElement="name"
                            labelName="Nombres:"
                            placeholder="Nombres"
                            value={props.values.name}
                            typeFormElement="text"
                            typeElement="input"
                            mandatoryElement={true}
                            hasError={inputValidate?.empty?.name}
                            msgError={inputValidate?.msg?.name}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, paternalSurname: e.target.value })}
                            idFormElement="paternalSurname"
                            labelName="Apelido Paterno:"
                            placeholder="Apelido Paterno"
                            value={props.values.paternalSurname}
                            typeFormElement="text"
                            typeElement="input"
                            mandatoryElement={true}
                            hasError={inputValidate?.empty?.paternalSurname}
                            msgError={inputValidate?.msg?.paternalSurname}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, maternalSurname: e.target.value })}
                            idFormElement="maternalSurname"
                            labelName="Apelido Materno:"
                            placeholder="Apelido Materno"
                            value={props.values.maternalSurname}
                            typeFormElement="text"
                            typeElement="input"
                            mandatoryElement={true}
                            hasError={inputValidate?.empty?.maternalSurname}
                            msgError={inputValidate?.msg?.maternalSurname}
                        />
                    </div>
                </div>
            </CGE.PanelSection>

            <CGE.PanelSection title={props.title_section_datos_personales_2}>
                <div className="row">
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, street: e.target.value })}
                            idFormElement="street"
                            labelName="Calle:"
                            placeholder="Calle"
                            value={props.values.street}
                            typeFormElement="text"
                            typeElement="input"
                            mandatoryElement={true}
                            hasError={inputValidate?.empty?.street}
                            msgError={inputValidate?.msg?.street}

                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, number: e.target.value })}
                            idFormElement="number"
                            labelName="Número:"
                            placeholder="Número"
                            value={props.values.number}
                            typeFormElement="text"
                            typeElement="input"
                            mandatoryElement={true}
                            hasError={inputValidate?.empty?.number}
                            msgError={inputValidate?.msg?.number}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, dpto: e.target.value })}
                            idFormElement="dpto"
                            labelName="Dpto:"
                            placeholder="Dpto"
                            value={props.values.dpto}
                            typeFormElement="text"
                            typeElement="input"
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => {
                                props.setValues({ ...props.values, region: e.target.value })
                                props.setIdRegion(e.target.value)
                            }}
                            idFormElement="region"
                            mandatoryElement={true}
                            labelName="Región:"
                            typeElement="select"
                            hasError={inputValidate?.empty?.region}
                            msgError={inputValidate?.msg?.region}
                            value={props.values.region}
                            listOptions={props.optionsRegion}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, commune: e.target.value })}
                            idFormElement="commune"
                            mandatoryElement={true}
                            labelName="Comuna:"
                            typeElement="select"
                            hasError={inputValidate?.empty?.commune}
                            msgError={inputValidate?.msg?.commune}
                            value={props.values.commune}
                            listOptions={props.optionsComunaRegion}
                        />
                    </div>
                </div>
            </CGE.PanelSection>

            <CGE.PanelSection title={props.title_section_datos_personales_3}>
                <div className="row">
                    <div className="col-md-1">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, prefixCell: e.target.value })}
                            idFormElement="prefixCell"
                            labelName="Teléfono:"
                            typeElement="select"
                            value={props.values.prefixCell}
                            listOptions={props.optionsPrefixCell}
                            
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, telephone: e.target.value })}
                            idFormElement="telephone"
                            placeholder=" Ejemplo: 26800700"
                            value={props.values.telephone}
                            style={{ marginTop: '40px'}}
                            hasError={inputValidate?.empty?.telephone || inputValidate?.validated?.telephone}
                            msgError={inputValidate?.msg?.telephone}
                            maxLength={8}
                            typeElement="input-mask"
                            formatChars={{
                                9: "[0-9]",
                            }}
                            mask="99999999"
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, cellPhone: e.target.value })}
                            idFormElement="cellPhone"
                            mandatoryElement={true}
                            labelName="Celular:"
                            placeholder=" Ejemplo: 93702132"
                            value={props.values.cellPhone}
                            hasError={inputValidate?.empty?.cellPhone || inputValidate?.validated?.cellPhone}
                            msgError={inputValidate?.msg?.cellPhone}
                            maxLength={9}
                            typeElement="input-mask"
                            formatChars={{
                                9: "[0-9]",
                            }}
                            mask="999999999"
                        />
                    </div>
                    <div class="col-md-6">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, email: e.target.value })}
                            idFormElement="email"
                            labelName="E-mail"
                            typeElement="input"
                            mandatoryElement={true}
                            typeFormElement="text"
                            value={props.values.email}
                            hasError={inputValidate?.empty?.email || inputValidate?.validated?.email}
                            msgError={inputValidate?.msg?.email}
                        />
                    </div>
                    <div class="col-md-6">
                        <CGE.FormsField
                            handleChange={(e) => props.setValues({ ...props.values, confirmEmail: e.target.value })}
                            idFormElement="confirmEmail"
                            labelName="Confirma tu E-mail"
                            typeElement="input"
                            mandatoryElement={true}
                            typeFormElement="text"
                            value={props.values.confirmEmail}
                            hasError={inputValidate?.empty?.confirmEmail || inputValidate?.validated?.confirmEmail}
                            msgError={inputValidate?.msg?.confirmEmail}
                        />
                    </div>
                    <div className="col-md-12">
                        <CGE.FormsField
                            checked={props.checkBox}
                            labelName=" Deseo recibir información de la empresa por correo electrónico."
                            handleChange={() => props.setCheckBox((val) => !val)}
                            idFormElement="emailNewsletter"
                            typeFormElement="checkbox"
                            mandatoryElement={true}
                            typeElement="input"
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <CGE.Button
                        label="Aceptar"
                        onClick={() => handleSubmit()}
                    />
                </div>
            </CGE.PanelSection>
        </CGE.Panel>
        
    </div>
  )
}

export default PersonalData
